import React, { useEffect, useState } from 'react';
import { ActivityIcon } from 'lucide-react';
import { META_PIXEL_ID, subscribeToPixelLog, type PixelLogEntry } from '../../utils/metaPixel';

/**
 * Panel de verificación del Meta Pixel. Solo se monta cuando se activa
 * la prop `debugPixel` de App: no forma parte de la página de venta.
 */
export function PixelDebugPanel() {
  const [entries, setEntries] = useState<PixelLogEntry[]>([]);
  useEffect(() => subscribeToPixelLog(setEntries), []);
  return <aside className="fixed left-4 top-4 z-[60] w-72 rounded-lg border border-gold/40 bg-ink/95 p-4 text-xs text-sand shadow-[0_20px_50px_-20px_rgba(0,0,0,0.9)]" data-id="element-122" data-mp="nbs0xtq5p2vl">
      <p className="flex items-center gap-2 font-semibold uppercase tracking-[0.16em] text-gold" data-id="element-123" data-mp="s3jr435eh6l7">
        <ActivityIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-124" data-mp="w3k4dkgrjbqo" />
        Meta Pixel {META_PIXEL_ID}
      </p>

      {entries.length === 0 ? <p className="mt-3 text-sand/70" data-id="element-125" data-mp="161zxtu39ix3c">Sin eventos registrados todavía.</p> : <ul className="mt-3 space-y-2" data-id="element-126" data-mp="3fcaasnls2w8x">
          {entries.slice(0, 6).map((entry, index) => <li key={`${entry.event}-${entry.at}-${index}`} className="border-t border-white/10 pt-2" data-id="element-127" data-mp="3adp90jqvo4id" data-mpi={index}>
              <span className="font-semibold text-cream" data-id="element-128" data-mp="36bkezjwip5v7">{entry.event}</span>{' '}
              <span className="text-sand/60" data-id="element-129" data-mp="31cr1vsl57gvk">{entry.at}</span>
              {entry.params ? <span className="block text-sand/70" data-id="element-130" data-mp="31f3tyykm77mc">
                  {entry.params.value ? `${entry.params.value} ${entry.params.currency ?? ''}` : ''}
                </span> : null}
            </li>)}
        </ul>}
    </aside>;
}